// extracted by mini-css-extract-plugin
module.exports = {"skeletonText":"SkeletonText_skeletonText__1RYiB","loading":"SkeletonText_loading__3u9-6"};